import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';

interface SuperAdminBlockProps {
  children: ReactNode;
}

// Force-redirect SuperAdmin users away from the tenant-facing layout to the
// admin cockpit. Tenant menus aren't designed for cross-tenant work, and the
// product brief explicitly mandates "kein Tenant-Switcher / nur Admin-Sidebar"
// for SuperAdmin.
export function SuperAdminBlock({ children }: SuperAdminBlockProps) {
  const isSuperAdmin = useAuthStore((s) => s.isSuperAdmin);
  if (isSuperAdmin) {
    return <Navigate to="/admin/tenants" replace />;
  }
  return <>{children}</>;
}
